import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "select-option-container" }
const _hoisted_2 = {
  key: 0,
  class: "select-secondary-line"
}

import Multiselect from '@vueform/multiselect'
import {PropType, toRef} from "vue";

import {useI18n} from "vue-i18n";

export default /*@__PURE__*/_defineComponent({
  __name: 'Select',
  props: {
  options: Array,
  mode: String,
  selected: [Number, String],
	disabled: Boolean,
  searchable: { type: Boolean, default: false},
  valueProp: { type: String, default: "id" },
  labelProp: { type: String, default: "name" },
  extraFields: { type: Array as PropType<string[]>, default: () => [] }
},
  emits: ['selectChanged'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();


const props = __props

const emit = __emit
let optionsSelected = toRef(props, 'selected');
const options = toRef(props, 'options');


function changeOptions(value) {
  emit('selectChanged', value);
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Multiselect), {
      modelValue: _unref(optionsSelected),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(optionsSelected) ? (optionsSelected).value = $event : optionsSelected = $event)),
      mode: __props.mode,
      label: __props.labelProp,
      valueProp: __props.valueProp,
      "close-on-select": true,
      "create-option": false,
      searchable: __props.searchable,
      options: options.value,
      disabled: __props.disabled,
      noOptionsText: _unref(t)('global.emptyList'),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (changeOptions($event)))
    }, {
      option: _withCtx(({ option }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(option[__props.labelProp]), 1),
          _renderSlot(_ctx.$slots, "option", { option: option }, () => [
            (__props.extraFields?.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.extraFields.map(field => option[field as keyof typeof option]).filter(Boolean).join(" • ")), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "mode", "label", "valueProp", "searchable", "options", "disabled", "noOptionsText"])
  ]))
}
}

})